import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id F1DEF74B-8116-4E0E-98BE-97A699812E5A
 * name language-fortran
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/language-fortran.svg
 * tags
 * - Developer / Languages 
 * - Brand / Logo 
 */
export const LanguageFortranIcon = createSvgIcon(<><path d="M5 4V6H6C6.55 6 7 6.45 7 7V17C7 17.55 6.55 18 6 18H5V20H14V18H12C11.45 18 11 17.55 11 17V13H13C13.55 13 14 13.45 14 14V16H16V8H14V10C14 10.55 13.55 11 13 11H11V6H16C17.11 6 18 7.34 18 9V10H20V4Z" /></>, 'LanguageFortranIcon');
export default LanguageFortranIcon